import { Icon } from '@platform/ui';
import { cx } from '@platform/core/lib/cx';
import type { IGroupPillProps } from './IGroupPillProps';

/**
 * Пігулка групи модулів (UIUX top-bar, прототип v4): 34px, відступи 0 12px 0 14px, 600, біла 88%; активна — біла пігулка з синім текстом
 * і «· модуль» (500, .8); відкрите меню — rgba(255,255,255,.16); «Головна» — іконка будинку; шеврон 11px повертається при відкритті.
 */
export function GroupPill({ label, title, home, active, sub, expanded, onClick }: IGroupPillProps) {
  return (
    <button type="button" className={cx('tb-pill', active && 'is-active', expanded && 'is-open')} aria-current={active ? 'page' : undefined}
      aria-haspopup="menu" aria-expanded={expanded} title={title} aria-label={title} onClick={onClick}>
      {home ? <Icon name="house" size={16} strokeWidth={2} /> : <span>{label}</span>}
      {active && sub && <span className="tb-pill__sub">· {sub}</span>}
      <Icon name="chevron-down" size={11} strokeWidth={2.6} className="tb-pill__chev" />
    </button>
  );
}
